export enum EContactCivility {
   empty = "",
   mister = "M",
   madam = "MME",
   mister_madam = "M_MME",
}

export const contactCivilityAsString = (contactCivility: EContactCivility): string => {
   switch (contactCivility) {
      case EContactCivility.mister:
         return "Monsieur";
      case EContactCivility.madam:
         return "Madame";
      case EContactCivility.mister_madam:
         return "Monsieur / Madame";
      case EContactCivility.empty:
      default:
         return "";
   }
};